import React from 'react';
import { Ellipsis, Icon } from '../../../../common';
import './style/index.less';
import { Position } from 'reactflow';
export default function ({ config, setConfig, instance }) {
    const { nodeStyle, nodeClassName, statusIcon, Handle, isDndPreview } = instance;
    const { icon, label, highlight } = config;
    const { width, height } = config;
    return (React.createElement("div", { className: `oflow-client--rounded-rectangle-node   
    ${highlight ? 'oflow-client--rounded-rectangle-node--highlight' : ''}  
    ${nodeClassName ? nodeClassName : ''}`, style: { width, height } },
        !isDndPreview ? (React.createElement(React.Fragment, null,
            React.createElement(Handle, { position: Position.Top, type: "target" }),
            React.createElement(Handle, { position: Position.Bottom, type: "source" }))) : null,
        React.createElement("div", { className: "oflow-client--rounded-rectangle-node--content", style: nodeStyle },
            icon ? (React.createElement("div", { className: "oflow-client--rounded-rectangle-node--icon", style: {
                    background: instance === null || instance === void 0 ? void 0 : instance.primaryColor,
                } },
                React.createElement(Icon, { icon: icon, style: { color: '#fff', width: 14, height: 14, fontSize: 14 } }))) : null,
            React.createElement("div", { className: "oflow-client--rounded-rectangle-node--title" },
                React.createElement(Ellipsis, null, label)),
            statusIcon ? (React.createElement(Icon, { icon: statusIcon, style: { color: '#fff', width: 12, height: 12, fontSize: 12 } })) : null)));
}
//# sourceMappingURL=index.js.map